import { useCallback } from 'react';
import { useBlocker, BlockerFunction } from 'react-router';

export default function BackButtonBlocker() {
  const shouldBlock = useCallback<BlockerFunction>(({ historyAction }) => {
    return historyAction === 'POP';
  }, []);
  useBlocker(shouldBlock);

  return null;
}
